var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkFilledHovered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87109 2.20703C3.45688 2.20703 3.12109 2.54282 3.12109 2.95703V14.4258C3.12109 14.6994 3.27013 14.9513 3.50996 15.0831C3.74979 15.2149 4.04235 15.2056 4.27331 15.0588L8.56701 12.3306L12.8607 15.0588C13.0917 15.2056 13.3842 15.2149 13.6241 15.0831C13.8639 14.9513 14.0129 14.6994 14.0129 14.4258V2.95703C14.0129 2.54282 13.6771 2.20703 13.2629 2.20703H3.87109Z",
    fill: "#227028"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkFilledHovered);
export default __webpack_public_path__ + "static/media/Bookmark-filled-hovered.dc2103eff087aa35f3caad44415f40be.svg";
export { ForwardRef as ReactComponent };